export default __webpack_public_path__ + "static/media/city.2a33a32f.png";